//import './Loader.css';
import style from '../../style.module.scss'
import loader from './loader_01.gif';

export const Loader = () => {
    return(
       <img className={style['loader']} src={loader}/>
    )
}